module.exports = __webpack_public_path__ + "static/media/city_planing.f8f67844.jpg";